import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames'

const IconReportsSVG = ({color, className, ...rest}) => {
    return (
        <svg {...rest} width="24" height="24" viewBox="0 0 24 24"
             className={classNames(['svg-icon svg-repords', className])}>
            <path d="M0,0H24V24H0Z" fill="none"/>
            <path fill={color}
                  d="M6.4,9.2h.2A1.4,1.4,0,0,1,8,10.6v7A1.4,1.4,0,0,1,6.6,19H6.4A1.4,1.4,0,0,1,5,17.6v-7A1.4,1.4,0,0,1,6.4,9.2ZM12,5a1.4,1.4,0,0,1,1.4,1.4V17.6a1.4,1.4,0,0,1-2.8,0V6.4A1.4,1.4,0,0,1,12,5Zm5.6,8A1.4,1.4,0,0,1,19,14.4v3.2a1.4,1.4,0,0,1-2.8,0V14.4A1.4,1.4,0,0,1,17.6,13Z"/>
        </svg>

    );
};

IconReportsSVG.propTypes = {
    color: PropTypes.string,
    className: PropTypes.string,
};

IconReportsSVG.defaultProps = {
    color: '#fff',
    className: '',
};

export default IconReportsSVG;